export interface IPageHtml5 {
  id?: number;
  code?: string;
  name?: string;
  description?: string;
  html?: string;
  css?: string;
  typescript?: string;
}

export class PageHtml5 implements IPageHtml5 {
  constructor(
    public id?: number,
    public code?: string,
    public name?: string,
    public description?: string,
    public html?: string,
    public css?: string,
    public typescript?: string
  ) {}
}
